import React from 'react';

const Opportunities = () => {
  return <div><h1>Opportunities</h1></div>;
};

export default Opportunities;
